module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "magnifier"
  }, [_c('div', {
    staticClass: "magnifier-small",
    style: ({
      width: _vm.width + 'px',
      height: _vm.height + 'px'
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mark",
    on: {
      "mousemove": function($event) {
        _vm.showMagnifier($event)
      },
      "mouseout": _vm.hideMagnifier
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "magnifier-floatBox",
    style: ({
      left: _vm.floatStyleData.l + 'px',
      top: _vm.floatStyleData.t + 'px'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "magnifier-big",
    style: ({
      left: _vm.width + 1 + 'px'
    })
  }, [_c('img', {
    staticClass: "magnifier-showBigImg",
    style: ({
      left: _vm.imgStyleData.l + 'px',
      top: _vm.imgStyleData.t + 'px'
    }),
    attrs: {
      "src": _vm.imgSrc
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-113a6876"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/magnifier/magnifier.vue
// module id = 798
// module chunks = 39